export default "__VITE_ASSET__pP7Ad3BL__"